export const hasValidDomain = (email) => {
    const keapMatcher = new RegExp('.*@keap\.app$'); // eslint-disable-line no-useless-escape
    const infusionmailMatcher = new RegExp('.*@infusionmail\.com$'); // eslint-disable-line no-useless-escape

    return !keapMatcher.test(email) && !infusionmailMatcher.test(email);
};
